import React from 'react';

const QuickListForCareMgmtContext = React.createContext({});
 
export {QuickListForCareMgmtContext};